<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton :content_1="quit_text" content_2="是否確認退出？"></QuitButton>
      <BackButton v-if="back_button" @click="goBack"></BackButton>
      <BackButton v-if="!back_button" back_url="testResult"></BackButton>
    </FabColumn>

    <ion-content class="follow-up-content">
      <div class="flow-content follow-up-flow">
      <!-- <div>
        <MainTitle text="免費評估" margin_top="short"></MainTitle>
        <MainSubtitle text=""></MainSubtitle>

        <div class="width-62 text-justify margin-auto">
          <MainDescribeHref text="「中大網上認知測試」是一個反映長者認知健康的評估。因為您在這測試中被評估為「需要關注」類別，建議你可以聯絡"></MainDescribeHref>
          <MainDescribeHref text="賽馬會耆智園" href="https://jccpa.org.hk"></MainDescribeHref>
          <MainDescribeHref text="或前往社會福利署各區的"></MainDescribeHref>
          <MainDescribeHref text="長者地區中心" href="https://www.swd.gov.hk/tc/index/site_pubsvc/page_elderly/sub_csselderly/id_districtel/"></MainDescribeHref>
          <MainDescribeHref text="作進一步查詢，並安排適合的詳細評估及跟進。"></MainDescribeHref>
        </div>

        <ConfirmButton text="繼續" @click="goSurveyPrepare"></ConfirmButton>
      </div> -->

      <div v-if="show_intro">
        <MainTitle text="免費評估" margin_top="short"></MainTitle>
        <MainSubtitle text="賽馬會「智康健」腦退化檢測及社區支援計劃"></MainSubtitle>
        <MainDescribe
          text="「中大網上認知測試」是一個反映長者認知健康的評估。因為您在這測試中被評估為「需要關注」類別，您已合資格參加賽馬會「智康健」腦退化檢測及社區支援計劃 。該計劃的參與機構會為你免費安排詳細評估及跟進。"
          style="text-align: justify"></MainDescribe>
      </div>

      <div v-if="show_wish">
        <MainTitle text="免費評估" margin_top="short"></MainTitle>
        <MainSubtitle text="賽馬會「智康健」腦退化檢測及社區支援計劃參加意願"></MainSubtitle>
        <FollowUpWish @getIsWish="getIsWish"></FollowUpWish>
      </div>

      <div v-if="show_join_info">
        <MainTitle text="免費評估" margin_top="short"></MainTitle>
        <MainSubtitle text="請確認以下資料以便相關機構有需要時可聯絡您"></MainSubtitle>
        <FollowUpInfo :user_info="user_info" is_join="1" :is_staff="is_staff" @getJoinInfo="getJoinInfo" ref="join_info">
        </FollowUpInfo>
      </div>

      <div v-if="show_no_join_info">
        <MainTitle text="不參加計劃原因" margin_top="short"></MainTitle>
        <MainSubtitle text="請讓我們了解您不參加賽馬會「智康健」腦退化檢測及社區支援計劃的原因"></MainSubtitle>
        <FollowUpInfo :user_info="user_info" is_join="0" @getNoJoinInfo="getNoJoinInfo" ref="no_join_info"></FollowUpInfo>
      </div>

      <div v-if="show_ngo_organization">
        <MainTitle text="免費評估" margin_top="short"></MainTitle>
        <MainSubtitle class="main-subtitle" text="選擇服務提供機構"></MainSubtitle>
        <MainDescribe text="您可以接受以下的社福機構為您提供賽馬會「智康健」腦退化檢測及社區支援計劃的服務。請根據您方便的地區，點選您的服務提供機構："></MainDescribe>
        <FollowUpOrganization @selectOrganization="selectOrganization"></FollowUpOrganization>
        <MainDescribe text="*上列地區以外的服務，請您選擇便利您的機構跟進。" tips_class="tips"></MainDescribe>
      </div>
      <ConfirmButton v-if="show_intro" class="flow-confirm-button" text="繼續" position="relative" @click="showStep('wish')"></ConfirmButton>
      <ConfirmButton v-if="show_wish && show_wish_button" class="flow-confirm-button" text="繼續" position="relative" @click="showByWish"></ConfirmButton>
      <ConfirmButton v-if="show_join_info" class="flow-confirm-button" text="提交" position="relative" @click="submitJoinInfo(true)"></ConfirmButton>
      <ConfirmButton v-if="show_no_join_info" class="flow-confirm-button" text="提交" position="relative" @click="submitJoinInfo(false)"></ConfirmButton>
      <ConfirmButton v-if="show_ngo_organization && show_ngo_button" class="flow-confirm-button" text="繼續" position="relative" @click="getOrganization"></ConfirmButton>
      <TestNumber :number="user_info.number"></TestNumber>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import { IonContent, IonPage } from "@ionic/vue";
import ConfirmButton from "../components/common/ConfirmButton";
import FollowUpWish from "../components/followUp/FollowUpWish";
import TestNumber from "../components/test/TestNumber";
import FollowUpInfo from "../components/followUp/FollowUpInfo";
import FollowUpOrganization from "../components/followUp/FollowUpOrganization";
import MainTitle from "../components/common/MainTitle";
import MainDescribe from "../components/common/MainDescribe";
import MainSubtitle from "../components/common/MainSubtitle";
import common from "../common";
import QuitButton from "../components/common/QuitButton";
import router from "../router";
import BackButton from "../components/common/BackButton";
export default {
  name: "FollowUp",
  components: {
    BackButton,
    QuitButton,
    MainSubtitle,
    MainDescribe,
    MainTitle,
    FollowUpOrganization,
    FollowUpInfo,
    TestNumber,
    FollowUpWish,
    ConfirmButton,
    WhiteBackground,
    Background,
    IonPage,
    IonContent
  },
  data() {
    return {
      user_info: {},
      test_id: 0,
      show_intro: false,
      show_wish: false,
      is_wish: false,
      show_no_join_info: false,
      show_join_info: false,
      show_ngo_organization: false,
      show_ngo_button: false,

      show_wish_button: false,
      need_follow_up: 0,
      name: '',
      organization_id: 0,
      reason: 0,
      other_reason: '',

      back_button: false,
      step_arr: [],

      is_staff: false,
      quit_text: '您的跟進記錄將不會被保留。',

    }
  },
  ionViewWillEnter() {
    common.getUserInfo().then(user_info => {
      this.user_info = user_info
    })
    common.getStorage('storage_test_id').then(test_id => {
      this.test_id = test_id;
    })
    common.getStorage('staff').then(staff => {
      if (staff) {
        this.is_staff = true;
      }
    })
    this.showStep('intro');
  },
  methods: {
    showStep: function (step) {
      this.back_button = this.step_arr.length;
      this.step_arr.push(step)

      for (const i in this.$data) {
        if (i.indexOf('show_') !== -1) {
          this.$data[i] = false;
          if (i.slice(5) == step) {
            this.$data[i] = true;
          }
        }
      }
    },
    getIsWish: function (value) {
      this.is_wish = value;
      this.show_wish_button = true;
    },
    showByWish: function () {
      if (this.is_wish) {
        this.quit_text = '您的跟進記錄將不會被保留。';
        // if (this.is_staff) {
        //   this.showStep('ngo_organization')
        // } else {
        //   this.showStep('join_info')
        // }
        this.showStep('join_info')
      } else {
        this.quit_text = '您的意見記錄將不會被保留。';
        this.showStep('no_join_info');
      }
    },
    getJoinInfo: function (info) {
      this.name = info.name;
      this.organization_id = info.organization_id;
    },
    getNoJoinInfo: function (info) {
      this.name = info.name;
      this.reason = info.reason;
      this.other_reason = info.other_reason;
    },
    submitJoinInfo: function (type) {
      if (type == true) {
        if (!this.$refs.join_info.getJoinInfo(this.user_info.ngo_id)) {
          return;
        }
      } else {
        if (!this.$refs.no_join_info.getNoJoinInfo()) {
          return;
        }
      }

      const loading = common.showLoading();
      common.apiPostData('/followUp', {
        test_id: this.test_id,
        name: this.name,
        is_join: this.is_wish ? 1 : 0,
        is_staff: this.is_staff,
        reason: this.reason,
        other_reason: this.other_reason,
      }, true, loading).then(res => {
        if (res === false) {
          return false;
        }

        common.setStorage('followUp_' + this.user_info.id, this.is_wish);

        if (this.is_wish) {
          router.replace('/surveyPrepare/join')
        } else {
          router.replace('/surveyPrepare/no_join')
        }

      })

      // if (type == true) {
      //   if (!this.$refs.join_info.getJoinInfo(this.organization_id)) {
      //     return;
      //   }
      // } else {
      //   if (!this.$refs.no_join_info.getNoJoinInfo()) {
      //     return;
      //   }
      // }

      // const loading = common.showLoading();
      // common.apiPostData('/followUp', {
      //   user_id: this.user_info.id,
      //   test_id: this.test_id,
      //   name: this.name,
      //   mobile: this.user_info.mobile,
      //   is_join: this.is_wish ? 1 : 0,
      //   organization_id: this.organization_id,
      //   reason: this.reason,
      //   other_reason: this.other_reason,
      //   is_staff: this.is_staff,
      //   number: this.user_info.number
      // }, true, loading).then(res => {
      //   if (res === false) {
      //     return false;
      //   }

      // common.setStorage('followUp_' + this.user_info.id, this.is_wish);

      // if (this.is_wish) {
      //   router.replace('/surveyPrepare/join')
      // } else {
      //   router.replace('/surveyPrepare/no_join')
      // }

      // })
    },
    goBack: function () {
      this.step_arr.pop()
      this.showStep(this.step_arr.pop());
    },
    getOrganization: function () {
      this.showStep('join_info')
    },
    selectOrganization: function (organization_id) {
      this.show_ngo_button = true;
      this.organization_id = organization_id;
    },
    goSurveyPrepare: function () {
      router.replace('/surveyPrepare/pass')
    }
  }
}
</script>

<style scoped>
.follow-up-flow {
  padding-bottom: clamp(2.5rem, 6vw, 4rem);
}

.follow-up-flow :deep(.short) {
  margin-top: 0;
}

.follow-up-flow :deep(.text-gray) {
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
}

.main-title {
  margin-top: 4vh;
}

.main-subtitle {
  margin-bottom: 2vh;
}

.flow-confirm-button :deep(.relative) {
  margin: clamp(0.75rem, 2vw, 1.25rem) auto 0;
}
</style>
